import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { postAPI, patchAPI } from "../API/ApiService";
import { BASE_URL } from "../constant/apiUrl";
import {
  libraryToggle,
  removeItemByContentId,
  toggleFavourite,
  formatDate,
} from "../utils/function";
import { setFetchFavourtie, setFavourites } from "../slices/internalPageSlice";
import { showErrorToast } from "../utils/Toast/toast";
const withCommonCardLogic = (WrappedComponent) => {
  return function CommonCardWrapper(props) {
    const { card, item, content, localState, setLocalState, setLoading } =
      props;

    const item1 = card ? card : item;
    const [isFavourite, setIsFavourite] = useState(
      item1?.favorite || item1?.is_favorite
    );

    const dispatch = useDispatch();
    const location = useLocation();

    const specialRoutes = ["/favorites"];
    const isDynamicSearchRoute = location.pathname.startsWith("/search");
    const isSpecialRoute = specialRoutes.includes(location.pathname);
    const libraryRoute = location.pathname.startsWith("/library");
    const { favourites, selectedAction } = useSelector(
      (store) => store.internalPage
    );

    const navigate = useNavigate();

    const addViewCount = async (contentId, goto, card) => {
      setLoading(true);
      try {
        const response = await patchAPI(`${BASE_URL}/content/${contentId}`, {});
        if (response?.status === 200) {
          const data = { ...card, content: content };
          navigate(goto, { state: data });
        }
      } catch (err) {
        showErrorToast(err.message);
      } finally {
        setLoading(false);
      }
    };

    const handleNavigate = (card, pageName) => {
      const contentId = card?.contentId || card?.id;
      if (pageName === "Link") {
        addViewCount(contentId, `/link/${contentId}`, card);
      } else if (pageName === "Document") {
        addViewCount(contentId, `/document/${contentId}`, card);
      } else if (pageName === "Video") {
        addViewCount(contentId, `/video-details/${contentId}`, card);
      }
    };

    const handleAddFavourite = async (card) => {
      setLoading(true);
      const contentId = card?.contentId ? card?.contentId : card?.id;
      try {
        const response = await postAPI(
          `${BASE_URL}/favorites/save?contentId=${contentId}&userId=1&favorite=${!isFavourite}`
        );
        if (response?.status === 200) {
          setIsFavourite(response?.data?.favorite);

          if (isSpecialRoute) {
            const updatedData = removeItemByContentId(
              favourites,
              response?.data?.contentId
            );

            dispatch(setFetchFavourtie(true));

            dispatch(setFavourites(updatedData));
          } else if (isDynamicSearchRoute) {
            dispatch(setFetchFavourtie(true));
          } else if (libraryRoute) {
            const result = libraryToggle(
              localState,
              contentId,
              content,
              response?.data.favorite
            );

            dispatch(selectedAction(result));
            setLocalState(result);
          } else {
            const result = toggleFavourite(
              localState,
              contentId,
              content,
              response?.data.favorite
            );

            dispatch(selectedAction(result));
            setLocalState(result);
          }
        }
      } catch (err) {
        console.error(err.message);
      } finally {
        setLoading(false);
      }
    };

    return (
      <WrappedComponent
        {...props}
        formatDate={formatDate}
        isFavourite={isFavourite}
        handleAddFavourite={() => handleAddFavourite(item1)}
        handleNavigate={(item, pageName) => handleNavigate(item, pageName)}
      />
    );
  };
};

export default withCommonCardLogic;
